import { render } from "./Door.vue?vue&type=template&id=d26c356e"
const script = {}
script.render = render

export default script